import React,{useEffect,useState,useContext, memo} from 'react'
import axios from 'axios'
import { AuthContextUser } from "../context/UserContext";
import { ToastContainer, toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import moment from "jalali-moment";

export const MedicalCommand = () => {

    const { currentUser } = useContext(AuthContextUser);

    const [search,setSearch] = useState('')
    const [searchT,setSearchT] = useState('')
    const [searchName,setSearchName] = useState('')
    const [mainList, setMainList] = useState([]);
    
const getAllProductsRT = async () => {
        const res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodList/${currentUser.nezam}&${search}`);
        setMainList(await res.json());
};

const getAllProductsTEL = async () => {
    const res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodListTEL/${currentUser.nezam}&${searchT.replace("/","-").replace("/","-")}`);
    setMainList(await res.json());
};
const getAllProductsName = async () => {
    const res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodListName/${currentUser.nezam}&${searchName}`);
    setMainList(await res.json());
};

      const [name,setName] = useState('')
      const [meli,setMeli] = useState('')
      const [tel,setTel] = useState('')
      const [year,setYesr] = useState('')
      const [insu,setInsu] = useState('')
      const [loca,setLoca]= useState('')

const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);

const [showbX, setShowbX] = useState(false);
const handleClosebX = () => setShowbX(false);
const handleShowbX = () => setShowbX(true);

const [ide,setIde] = useState('')

const [newMeli,setNewMeli] = useState('');

const undelUpdaye = (id,nameA,meliA,telA,yearA,insuA,loc) => {
    setName(nameA)
    setMeli(meliA)
    setNewMeli(meli)
    setTel(telA)
    setYesr(yearA)
    setInsu(insuA)
    setIde(id)
    setLoca(loc)
    handleShowb(true)
}

const updateCode = async(meliA) =>{
    try{
    await axios.put(`https://clinic.salamatpayanew.ir/Register/updateWrite/${meli}`,{
        meli:newMeli
    }).then(() =>{
       // toast.success("ویرایش با موفقیت انجام شد")
       console.log('ERR')
    }).catch((err) => {
        toast.error("خطا در ویرایش اطلاعات")
    })
 }catch(err){
    toast.error("خطا در ویرایش اطلاعات")
 }
}
const updatePan = async(meli) =>{
    try{
    await axios.put(`https://clinic.salamatpayanew.ir/Register/updatePatnit/${meli}`,{
        stat:'2'
    }).then(() =>{
        toast.success("ارجاع انجام شد - لطفا روی ارجاع به پزشک بزنید")
    }).catch((err) => {
        toast.error("خطا در ارجاع")
    })
 }catch(err){
    toast.error("خطا در ارجاع اطلاعات")
 }
}

const updateHandelUser = async(ide) => {
    try{
      updateCode(newMeli);
   await axios.put(`https://clinic.salamatpayanew.ir/Register/update/${ide}`,{
        name:name,
        meli:newMeli,
        tel:tel,
        year:year,
        insu:insu,
        loca:loca
    }).then(() =>{
        toast.success("ویرایش با موفقیت انجام شد")
    }).catch((err) => {
        toast.error("خطا در ویرایش اطلاعات")
    })
    handleCloseb(true)
  }catch(err){
    toast.error('خطا در ویرایش')
  }
}
// name	meli	year	type	stat	sts	nezam	date
// date: moment(new Date(), "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD"),
 
// const [date,setDate] = useState(moment(new Date(), "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD"));
const today = moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD");

/* const [vil,setVil] = useState([])

const checkMeli = async(meliE) => {
    const res = await fetch(
        `https://clinic.salamatpayanew.ir/MedicalCommand/requestmelCode/${meliE}`
        )
        setVil(await res.json())
      //  alert(res.data.meli)
/*            axios.post("https://clinic.salamatpayanew.ir/Register/pat_writeTo",{
                nezam:currentUser.nezam,
                meli:meliE,
                date:0,
}) }*/      

/* const patwrite = async() => {
    await axios.post("https://clinic.salamatpayanew.ir/Register/pat_writeTo",{
        nezam:currentUser.nezam,
        meli:meliE,
        date:0,
    })
 } */

const insertDoctor = async(nameE,meliE,yearE,insuE) => {
   await axios.post("https://clinic.salamatpayanew.ir/Register/statDoctor",{
        name:nameE,
        meli:meliE,
        year:yearE,
        type:"ارجاع شده",
        stat:"1",
        nezam:currentUser.nezam,
        date: moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD"),
        insu:insuE
    }).then(() => {
        toast.success("ارجاع با موفقیت انجام شد")
          setMainList([])  
    }).catch((err) =>{
        toast.warning("این بیمار به پزشک ارجاع شده است")
    })
}

const [userList, setUserList] = useState([]);

 useEffect(() => {
    const getAllProductsRT = async () => {
        const res = await fetch(
        `https://clinic.salamatpayanew.ir/Register/filterDate/${currentUser.nezam}&${today}`
        );
    setUserList(await res.json());
       
    };
    getAllProductsRT();

},[userList]);


const handelDelete = async(id) => {
    try{
       axios
      .delete(`https://clinic.salamatpayanew.ir/Register/deleteDate/${id}`)
      .then((response) => {
        setUserList((values) => {
          return values.filter((item) => item.id !== id);
        });
        toast.success("حذف  با موفقیت انجام شد");
      });
    }catch(err){
        toast.error("عملیات حذف غیر فعال میباشد")
    }
}

const [servl,setServl] = useState([])

const [sum,setSum] = useState(0)

var temp = 0;

const [srvMeli,setServMeli] = useState();

const serviceList = async(meli) =>{
    setServMeli(meli);
    setSum(0)
const res = await fetch(
    `https://clinic.salamatpayanew.ir/Register/filterServiceR/${meli}&${today}`
       );
setServl(await res.json());

    handleShowbX(true)
}

const handelSum = async() => {
    await axios.put(`https://clinic.salamatpayanew.ir/admin/UpdateServL/${srvMeli}&${today}`,{
        stat: '3'
    });
    handleClosebX(true)
}

const updateHandelBack = async(id) =>{
    await axios.put(`https://clinic.salamatpayanew.ir/admin/updateBackFor/${id}`,{
        stat: '1'
    });
}

const [chk1,setChk1] = useState(false)
const [chk2,setChk2] = useState(true)
const handelr =() =>{
    if(chk1 === true){
        
    }else if(chk2=== true){

    }
}

if (currentUser.meli === null) {
    toast.warning("Error Session Erp")
} else {

    return (
 <>
 <section class="m-0 content" dir='rtl'>
        <div class="row">
            <div class="d-flex flex-column flex-md-row justify-content-between">
            
                        <div class="custom-form-control form-group position-relative w-60">
                        <input type="text" maxLength={11} class="form-control" placeholder='کد ملی' onChange={(e) => setSearch(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-60 ms-2">
                        <button className='btn btn-info mt-4' onClick={getAllProductsRT}>کد ملی</button>
                        </div>
                        
                        <div class="custom-form-control form-group position-relative w-60">
                        <input type="text"  class="form-control" placeholder='جستجو تاریخ تولد' onChange={(e) => setSearchT(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-60 ms-2">
                        <button className='btn btn-primary mt-4' onClick={getAllProductsTEL}>تاریخ تولد</button>
                        </div>      
                        <div class="custom-form-control form-group position-relative w-60">
                        <input type="text"  class="form-control" placeholder='نام و نام خانوادگی' onChange={(e) => setSearchName(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-60 ms-2">
                        <button className='btn btn-warning mt-4' onClick={getAllProductsName}>جستجو نام</button>
                        </div> 
                    </div>
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                                <th><span>ردیف</span></th>
                                <th><span>نام بیمار</span></th>
                                <th><span>کد ملی</span></th>
                                <th><span>شماره تماس</span></th>
                                <th><span>تاریخ تولد</span></th>
                                <th><span>ارجاع</span></th>
                                <th><span>نوبت</span></th>
                                <th><span>ویرایش</span></th>
                            </tr>
                        </thead>

                        {mainList
                .map((item, index) => {
                    const { id, name,meli,tel,year,insu,loca } = item;
                  return (
                    <tbody
                      class="table-group-divider table-divider-color"
                      key={item.id}
                    >
                            <tr>
                                <td>{index+1}</td>
                                 <td>{item.name}</td>
                                <td>{item.meli}</td>
                                <td>{item.tel}</td>
                                <td>{item.insu}</td>
                                <td><button className='btn btn-primary' onClick={() => insertDoctor(name,meli,year,insu)}>ارجاع به پزشک</button></td>
                                <td><button className='btn btn-warning'>ثبت نوبت</button></td>
                                <td><button className='btn btn-success' onClick={() => undelUpdaye(id,name,meli,tel,year,insu,loca)}>ویرایش</button></td>
                                <td><button className='btn btn-danger' onClick={() => updatePan(meli)}>ارجاع</button></td>
                            </tr>
                        </tbody>
                    );
                })}
                    </table>
                       
                </div>
            </div>
        </section>

        <section class="m-0 content" dir='rtl'>
            <h5>بیماران ارجاع داده شده به پزشک</h5>
            <div class="row">
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                                <td>ردیف</td>
                                <th><span>نام بیمار</span></th>
                                <th><span>کد ملی</span></th>
                                <th><span>تاریخ تولد</span></th>
                                <th><span>وضعیت</span></th>
                                <th><span>برگشت به پزشک</span></th>
                                <th><span>بررسی پزشک</span></th>
                                <th><span>سرویس ها</span></th>
                                <th><span>حذف</span></th>
                            </tr>
                        </thead>

                        {userList
                .map((item, index) => {
                    const { id, name,meli,tel,year,insu,stat } = item;
                  return (
                    <tbody
                      class="table-group-divider table-divider-color"
                      key={item.id}
                    >
                            <tr>
                                <td>{index +1}</td>
                                <td>{item.name}</td>
                                <td>{item.meli}</td>
                                <td>{item.insu}</td>
                                <td>{item.type}</td>
                                <td>
                                <img src='/img/bac.png' height={"25px"} width={"25px"} title='بازگشت به پزشک' style={{cursor:'pointer'}} onClick={(e) => updateHandelBack(id)}/>
                                </td>
                                <td>
                                { stat === '2' ? 
                                        <p style={{color:'green'}}>{item.sts}</p>
                                :
                                stat === '1' ?
                                        <p>معاینه توسط پزشک</p>
                                  :
                                  <p style={{color:'red'}}>پایان یافته</p>                                    
                                }
                                    
                                </td>
                                <td>
                                { 
                                 stat === '2' ?
                                      <img src='/img/cl.png' height={"25px"} width={"25px"} title='نمایش سرویس' style={{cursor:'pointer'}} onClick={() => serviceList(meli)}/>
                                      :
                                 stat === '1' ?
                                 <p>معاینه پزشک</p> 
                                 :
                                 <p style={{color:'red'}}>خاتمه یافته</p>  
           
                                }
                 
                                </td>
                                <td>
                                    { stat === '1' ? (
                                        <img src='/img/del.png' height={"25px"} width={"25px"} title='حذف' style={{cursor:'pointer'}} onClick={() => handelDelete(id)}/>
                                    ):(
                                      <label style={{color:'blue'}}>حذف غیر فعال</label>
                                    )
                                    
                                    }
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
                    </table>

                </div>
            </div>
        </section>
<Modal show={showb} onHide={handleCloseb} className='' size='lg'>
        <Modal.Body>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100" dir='rtl'>
                        <div class="custom-form-control form-group position-relative w-100">
                            <input type="text" maxLength={50} class="form-control pr-16 my-2" placeholder='نام و نام خانوادگی' value={name} onChange={(e) => setName(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-100 m-0 me-md-3">
                            <input type="text" maxLength={10} readOnly class="form-control pr-16 my-2" placeholder="کد ملی"  value={meli}  onChange={(e) => setMeli(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-100 m-0 me-md-3">
                        <input type="text" maxLength={10} class="form-control pr-16 my-2" placeholder="کد ملی"   onChange={(e) => setNewMeli(e.target.value)}/>
                        </div>
                    </div>
                    <div class="custom-form-control form-group position-relative w-100 me-md-3" dir='rtl'>
                    <div class="custom-form-control form-group position-relative w-100 m-0 me-md-3">
                            <input type="text" maxLength={11} class="form-control pr-16 my-2" placeholder="شماره همراه" value={tel} onChange={(e) => setTel(e.target.value)} />
                        </div>
                    <div class="custom-form-control form-group position-relative w-100 m-0 me-md-3">
                            <input type="text" maxLength={10} class="form-control pr-16 my-2" placeholder="تاریخ تولد" value={insu} onChange={(e) => setInsu(e.target.value)}/>
                        </div>
                <select class="form-select form-control pr-16 my-2" aria-label="Default select example" value={year} onChange={(e) => setYesr(e.target.value)}>
                                <option selected>نوع بیمه</option>
                                <option value="آزاد">آزاد</option>
                                <option value="نیر وهای مسلح">نیروهای مسلح</option>
                                <option value="تامین اجتماعی">تامین اجتماعی</option>
                            </select>
                   <select class="form-select form-control pr-16 my-2" aria-label="Default select example" value={loca} onChange={(e) => setLoca(e.target.value)}>
                                <option selected>انتخاب اتباع</option>
                                <option value="افغانی">افغانی</option>
                                <option value="عرب">عرب</option>
                                <option value="سایر">سایر</option>
                    </select>
             </div>
        </Modal.Body>
        <button className='btn btn-primary' onClick={() => updateHandelUser(ide)}>ویرایش</button>
      </Modal>

      <Modal show={showbX} onHide={handleClosebX}>
        <Modal.Body>
                <div class="table-responsive" dir='rtl'>
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                                <th>نام سرویس</th>
                                <th>مبلغ</th>
                            </tr>
                        </thead>
                    {servl
                .map((item, index) => {
                    const { id,name,price} = item;
                  return (
                    <tbody
                      class="table-group-divider table-divider-color"
                      key={item.id}>
                            <tr>
                                <td>{item.name}</td>
                                <td>{item.price}</td>
                            </tr>
                        </tbody>
                    );
                })}

         </table>
            {
              servl.map((values) => {
                temp = temp + values.price * 1
               })  
            }
           جمع کل سرویس  :  {temp}
        <hr />
        <div style={{textAlign:'center'}}>
       <button className='btn btn-warning' onClick={handelSum}>تایید - پرداخت</button>
       </div>
  </div>
  </Modal.Body>
</Modal>

<ToastContainer
        position="top-left"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
   </>
  )
  }
}
